/** Host-provided overrides when Bernoulli is embedded (e.g. Info360 Model shell). */
let embeddedAgentBaseUrl: string | undefined;
let embeddedAuthToken: string | undefined;
let embeddedTenantId: string | undefined;
let embeddedProductLineName: string | undefined;

export const setEmbeddedAgentBaseUrl = (url: string | undefined): void => {
  embeddedAgentBaseUrl = url?.replace(/\/$/, '');
};

export const getEmbeddedAgentBaseUrl = (): string | undefined =>
  embeddedAgentBaseUrl;

export const setEmbeddedAuthToken = (token: string | undefined): void => {
  embeddedAuthToken = token?.trim() || undefined;
};

export const getEmbeddedAuthToken = (): string | undefined => embeddedAuthToken;

export const setEmbeddedTenantId = (tenantId: string | undefined): void => {
  embeddedTenantId = tenantId?.trim() || undefined;
};

export const getEmbeddedTenantId = (): string | undefined => embeddedTenantId;

export const setEmbeddedProductLineName = (
  productLineName: string | undefined,
): void => {
  embeddedProductLineName = productLineName?.trim() || undefined;
};

export const getEmbeddedProductLineName = (): string | undefined =>
  embeddedProductLineName;

/** True when iframe embed has host auth token plus tenant and product line. */
export const isEmbedHostContextReady = (): boolean =>
  Boolean(
    getEmbeddedAuthToken() &&
      getEmbeddedTenantId() &&
      getEmbeddedProductLineName(),
  );

/** Clear all host embed overrides (call on unmount). */
export const clearEmbeddedHostContext = (): void => {
  embeddedAgentBaseUrl = undefined;
  embeddedAuthToken = undefined;
  embeddedTenantId = undefined;
  embeddedProductLineName = undefined;
};
